module.exports = __webpack_public_path__ + "img/money-back.28e86eaf.svg";